import { render, staticRenderFns } from "./MediaSelectInput.vue?vue&type=template&id=212f4d54"
import script from "./MediaSelectInput.vue?vue&type=script&lang=js"
export * from "./MediaSelectInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports